module.exports = __webpack_public_path__ + "media/img/android-icon-36x36-91a29ad5eff37e594a647b394e1711e2.png";